import React, { useState, useEffect } from 'react'
import { Message } from 'rsuite'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import ApproveWithdrawWidget from '../../../widgets/progressReportWidget/withdraw/ApproveWithdrawWidget'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'

import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import { startLoading, doneLoading } from '../../../utils/loading'
import {
  getWidthdrawRequestApprove,
  getWithdrawRequestStatus,
  getWithdrawRequestBudget,
} from '../../../redux/actions/withdrawRequest'
import AgreementAdditionalWidgets from '../../../widgets/agreementAdditional/AgreementAdditionalWidgets'
import Budget from '../../../widgets/budget/Budget'
import { downloadWithdrawPaymentFile } from '../../../redux/actions/withdrawRequest'
import PdfRenderWidgets from '../../../widgets/pdfWidgets/PdfRenderWidgets'

export default function ApproveWithdraw() {
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  const [paymentSchema, setPaymentSchema] = useState()
  const [isPdfError, setIsPdfError] = useState(false)
  const [previewPdf, setPreviewPdf] = useState()
  const [isLoadingPDF, setIsLoadingPDF] = useState(false)
  const [withdrawRequestStatusSchema, setWithdrawRequestStatusSchema] = useState()

  const projectId = sessionStorage.getItem('projectId')

  useEffect(() => {
    if (projectId) {
      handleGetSchema(projectId)
      //handleGetDownloadWithdrawPaymentFile(schema?.forms?.requestNote?.requestId)
    }
  }, [projectId])

  useEffect(() => {
    if (schema?.forms?.requestNote?.requestId) {
      handleGetDownloadWithdrawPaymentFile(projectId, schema?.forms?.requestNote?.requestId)
    }
  }, [schema])

  const handleGetSchema = async (projectVersionId) => {
    setIsLoading(true)
    startLoading()
    try {
      const response = await getWidthdrawRequestApprove(projectVersionId)
      setSchema(response)

      // const _response = await getPaymentCheck(projectVersionId)
      // setPaymentSchema(_response)

      if (response) {
        const payment = await getWithdrawRequestBudget(
          projectId,
          response.forms.requestNote.requestId
        )
        console.log('PaymentSchema', payment)
        setPaymentSchema(payment)
      }

      const _withdrawRequestStatus = await getWithdrawRequestStatus(projectId)
      setWithdrawRequestStatusSchema(_withdrawRequestStatus)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleGetDownloadWithdrawPaymentFile = async (requestId) => {
    startLoading()
    //setIsLoading(true)
    setIsPdfError(false)
    setIsLoadingPDF(true)
    try {
      const response = await downloadWithdrawPaymentFile(projectId, requestId)
      console.log('response preview pdf', response)
      if (response) {
        setPreviewPdf(response)
        setIsPdfError(false)
      } else {
        setIsPdfError(true)
      }
    } catch (e) {
      setIsPdfError(true)
    }
    //setIsLoading(false)
    setIsLoadingPDF(false)
    doneLoading()
  }

  if (error) {
    return (
      <SidebarProposal>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <>
      <SidebarProposal statusDefault={8}>
        <ContentHeader header={schema?.header} subHeader={schema?.subHeader} />

        {schema?.forms?.agreementDetails && (
          <AgreementAdditionalWidgets formSchema={schema.forms.agreementDetails} />
        )}

        {isPdfError ? (
          <Message showIcon type="error" description={'ไม่พบไฟล์ PDF'} />
        ) : (
          <PdfRenderWidgets
            file={previewPdf}
            isLoading={isLoadingPDF}
            fileName={'แบบขอเบิกเงินโครงการ'}
            header={'แบบขอเบิกเงินโครงการ'}
            loadingMessage={'กรุณารอสักครู่ ระบบกำลังสร้าง PDF แบบขอเบิกเงินโครงการ...'}
            onReload={() => {
              handleGetDownloadWithdrawPaymentFile(schema?.forms?.requestNote?.requestId)
            }}
            firstExpandToReload={true}
          />
        )}
        <br />

        {/* งบประมาณโครงการ และ งวดเบิกจ่าย */}
        <Budget
          schema={paymentSchema?.forms}
          isEditable={false}
          defaultExpandAllRows={true}
          isShowBudgetSubmitButton={false}
          isCollapseAllTableRow={false}
          isHideBudgetPlan={true}
          isHidePeriodExpenses
          isHideBudgetInstallmentPlan
          //onClickConfirmBudget={handleConfirmBudget}
          withdrawRequestStatusSchema={withdrawRequestStatusSchema}
        />
        <br />

        {schema?.forms?.requestNote?.note && (
          <ApproveWithdrawWidget
            showCommandButton={true}
            schema={schema.forms.requestNote}
            disabled={schema.disabled}
          />
        )}
      </SidebarProposal>
    </>
  )
}
